import { IPatchItem } from './interface';

function apply(patchData: Array<IPatchItem>, source: Object = {}): Promise<Object> {
    return new Promise(async function (resolve, reject) {
        try {
            const jsonpatch = await import('fast-json-patch');
            const validatePatch = true;
            const mutateDocument = false;
            const result = jsonpatch.applyPatch<Object>(
                source,
                patchData as any,
                validatePatch,
                mutateDocument,
            ).newDocument;
            resolve(result);
        } catch (error) {
            console.error(`Failed to patch: ${JSON.stringify(error)}`);
            reject(error);
        }
    });
}

export default apply;
